import React from 'react';
import Router from './router/Router';
import { requestData } from './helpers/axios/Get'
import { connect } from 'react-redux'
import {
  TOKEN_URL,
  FETCH_TOKEN_DATA_PENDING,
  FETCH_TOKEN_DATA_SUCCESS,
  FETCH_TOKEN_DATA_ERROR,
  FETCH_FILE_WHITELIST_SUCCESS,
  FETCH_FILE_WHITELIST_PENDING,
  FETCH_FILE_WHITELIST_ERROR,
  FETCH_FILTER_DATA_SET_PENDING,
  FETCH_FILTER_DATA_SET_SUCCESS,
  FETCH_FILTER_DATA_SET_ERROR,
  FETCH_FILTER_CATEGORY_SET_SUCCESS,
  FETCH_FILTER_CATEGORY_SET_PENDING,
  FETCH_FILTER_CATEGORY_SET_ERROR,
  FETCH_FOLDER_BLACKLIST_SUCCESS,
  FETCH_FOLDER_BLACKLIST_PENDING,
  FETCH_FOLDER_BLACKLIST_ERROR,
  FETCH_GENERAL_SETTINGS_SUCCESS,
  FETCH_GENERAL_SETTINGS_PENDING,
  FETCH_GENERAL_SETTINGS_ERROR,
  FETCH_PROJECT_DATA_CONFIG_SUCCESS,
  FETCH_PROJECT_DATA_CONFIG_PENDING,
  FETCH_PROJECT_DATA_CONFIG_ERROR,
  FETCH_CALCULATIONS_CONFIG_SUCCESS,
  FETCH_CALCULATIONS_CONFIG_PENDING,
  FETCH_CALCULATIONS_CONFIG_ERROR,
  REQUEST_MARKDOWN_SUCCESS,
  REQUEST_MARKDOWN_PENDING,
  REQUEST_MARKDOWN_FAILED
} from './helpers/constants/Constants';


let attribute = null
let category = null

export function attributes() {
  return attribute
}

export function allCategories() {
  return category
}


class App extends React.Component {

  componentDidMount() {
    this.props.onrequestModelDataReducer();
    this.props.onrequestFileWhiteList();
    this.props.onrequestFilterDataSet();
    this.props.onrequestFilterCategorySet();
    this.props.onrequestFolderBlackListSet();
    this.props.onrequestProjectDataConfig();
    this.props.onrequestCalculationsConfig();
    this.props.getMarkdown();
    this.props.onrequestGeneralSettingsSet();
  }

  componentDidUpdate() {
      category =  this.props.state.requestFilterCategoryReducer.data;
      attribute =  this.props.state.requestFilterDataSetReducer.data;  
  }

  render() {
    return (
      <Router />
    );
  }
};

const mapStateToProps = state => (
  {
    state
  }
)

const mapDispatchToProps = (dispatch) => {
  return {
    onrequestModelDataReducer: () => dispatch(requestData(
      TOKEN_URL,
      {
        pending: FETCH_TOKEN_DATA_PENDING,
        error: FETCH_TOKEN_DATA_ERROR,
        success: FETCH_TOKEN_DATA_SUCCESS
      })),
    onrequestFileWhiteList: () => dispatch(requestData(
      '/config/FileExtensionWhitelist.json',
      {
        success: FETCH_FILE_WHITELIST_SUCCESS,
        pending: FETCH_FILE_WHITELIST_PENDING,
        error: FETCH_FILE_WHITELIST_ERROR
      })),
    onrequestFilterDataSet: () => dispatch(requestData(
      '/config/FilterPropWhitelist.json',
      {
        success: FETCH_FILTER_DATA_SET_SUCCESS,
        pending: FETCH_FILTER_DATA_SET_PENDING,
        error: FETCH_FILTER_DATA_SET_ERROR
      })),
    onrequestFilterCategorySet: () => dispatch(requestData(
      '/config/FilterCategoryWhitelist.json',
      {
        success: FETCH_FILTER_CATEGORY_SET_SUCCESS,
        pending: FETCH_FILTER_CATEGORY_SET_PENDING,
        error: FETCH_FILTER_CATEGORY_SET_ERROR
      })),
    onrequestFolderBlackListSet: () => dispatch(requestData(
      '/config/FolderExtensionBlacklist.json',
      {
        success: FETCH_FOLDER_BLACKLIST_SUCCESS,
        pending: FETCH_FOLDER_BLACKLIST_PENDING,
        error: FETCH_FOLDER_BLACKLIST_ERROR
      })),
    onrequestGeneralSettingsSet: () => dispatch(requestData(
      '/config/GeneralSettings.json',
      {
        success: FETCH_GENERAL_SETTINGS_SUCCESS,
        pending: FETCH_GENERAL_SETTINGS_PENDING,
        error: FETCH_GENERAL_SETTINGS_ERROR
      })),
    onrequestProjectDataConfig: () => dispatch(requestData(
      '/config/project_data_config.json',
      {
        success: FETCH_PROJECT_DATA_CONFIG_SUCCESS,
        pending: FETCH_PROJECT_DATA_CONFIG_PENDING,
        error: FETCH_PROJECT_DATA_CONFIG_ERROR
      })),
    onrequestCalculationsConfig: () => dispatch(requestData(
      '/config/calculations_config.json',
      {
        success: FETCH_CALCULATIONS_CONFIG_SUCCESS,
        pending: FETCH_CALCULATIONS_CONFIG_PENDING,
        error: FETCH_CALCULATIONS_CONFIG_ERROR
      })),
    getMarkdown: () => dispatch(requestData(
      '/config/startpage.md',
      {
        success: REQUEST_MARKDOWN_SUCCESS,
        pending: REQUEST_MARKDOWN_PENDING,
        error: REQUEST_MARKDOWN_FAILED
      }))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);